{
  "dashboardTitle": "Job Scheduler",
  "dashboardSubtitle": "Monitorizare și gestionare job-uri programate",
  "allDefinitions": "Toate definițiile",
  "allExecutions": "Toate execuțiile",
  "newJobDefinition": "Job nou",
  "loading": "Se încarcă...",
  "totalDefinitions": "Total definiții",
  "activeDefinitions": "Definiții active",
  "completedToday": "Finalizate azi",
  "failedToday": "Eșuate azi",
  "jobDefinitions": "Definiții Job-uri",
  "recentExecutions": "Execuții recente",
  "viewAll": "Vezi toate",
  "name": "Nume",
  "jobType": "Tip job",
  "handlerType": "Tip handler",
  "cronExpression": "Expresie cron",
  "status": "Status",
  "actions": "Acțiuni",
  "jobDefinition": "Definiție job",
  "startedAt": "Început la",
  "duration": "Durată",
  "attempt": "Tentativă",
  "active": "Activ",
  "inactive": "Inactiv",
  "edit": "Editează",
  "activate": "Activează",
  "deactivate": "Dezactivează",
  "triggerNow": "Declanșează acum",
  "viewDetail": "Vezi detalii",
  "toggleSuccess": "Succes",
  "jobActivated": "Job-ul a fost activat cu succes",
  "jobDeactivated": "Job-ul a fost dezactivat cu succes",
  "triggerSuccess": "Succes",
  "jobTriggered": "Job-ul a fost declanșat cu succes",
  "noJobDefinitions": "Nu există definiții de job-uri",
  "noRecentExecutions": "Nu există execuții recente",
  "createFirst": "Creează primul job",
  "breadCrumbs": {
    "jobScheduler": "Job Scheduler",
    "dashboard": "Tablou de bord"
  }
}
